import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Empty, Modal, Spin, Tag, Typography } from "antd";
import { EditOutlined, LoadingOutlined, SendOutlined } from "@ant-design/icons";
import templateStore from "@/store/templateStore";
import { loginStore } from "@/store/loginStore";
import scanStore from "@/store/scanStore";
import { templates as templateOptions } from "@/constants";
import { GetLocalStorage } from "@/utils/helper";

export default function MyTemplates() {
  const navigate = useNavigate();
  const { token } = loginStore();
  const { templates, loading, fetchTemplates, publishTemplate } = templateStore();
  const { setCusTemplate } = scanStore();
  const [publishLoadingId, setPublishLoadingId] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    fetchTemplates();
  }, [token]);

  const getTemplateName = (type: string) => {
    return templateOptions.find((t) => t.key === type)?.name ?? type;
  };

  const getTemplateIcon = (type: string) => {
    return templateOptions.find((t) => t.key === type)?.icon;
  };

  const handlePublish = (templateId: string) => {
    const serial = GetLocalStorage("scan-storage", "serial");
    if (!serial) return;
    Modal.confirm({
      title: "Xác nhận publish",
      content: "Bạn có chắc muốn publish template này không?",
      okText: "Publish",
      cancelText: "Hủy",
      onOk: async () => {
        setPublishLoadingId(templateId);
        const success = await publishTemplate(templateId, serial);
        setPublishLoadingId(null);
        if (success) {
          const published = templates.find((t) => t.xid === templateId);
          if (published) setCusTemplate({ ...published, status: "published" } as any);
          navigate("/view");
        }
      },
    });
  };

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />} />
      </div>
    );
  }

  return (
    <section className="container h-full">
      {templates.length === 0 ? (
        <Empty description="Bạn chưa có template nào" />
      ) : (
        <div className="flex flex-col gap-3">
          {templates.map((item) => {
            const icon = getTemplateIcon(item.type);
            return (
              <div key={item.xid} className="flex items-center gap-3 rounded-xl border border-[#949494] bg-white p-3">
                {icon && <img src={icon} alt={item.type} className="h-10 w-10" />}
                <div className="flex-1">
                  <Typography.Text strong>{getTemplateName(item.type)}</Typography.Text>
                  {item.status && (
                    <div className="mt-1">
                      <Tag color={item.status === "published" ? "green" : "default"}>
                        {item.status === "published" ? "Đã publish" : "Nháp"}
                      </Tag>
                    </div>
                  )}
                </div>
                <div className="flex gap-2">
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => navigate("/create", { state: { template: item } })}
                  >
                    Sửa
                  </Button>
                  {item.status !== "published" && (
                    <Button
                      type="primary"
                      size="small"
                      icon={<SendOutlined />}
                      loading={publishLoadingId === item.xid}
                      onClick={() => handlePublish(item.xid)}
                    >
                      Publish
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
